import { useState } from 'react';
import { Box, Button, Flex, Heading, IconButton } from '@chakra-ui/react';
import { RiAddFill, RiFilter2Line } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';
import useGetPortfolioList from '@hooks/useGetPortfolioList';
import usePaginationParams from '@hooks/usePaginationParams';

import UpsertDialog from './components/UpsertDialog';
import PortfolioCard from './components/PortfolioCard';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const Portfolio = () => {
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const { checkIfHasRole } = useAuthContext();

  const {
    getPortfolios,
    portfolios,
    totalPages,
    loading,
  } = useGetPortfolioList();

  usePaginationParams({ onParamsChange: getPortfolios });

  const getCurrentComponent = () => {
    if (loading && portfolios.length === 0) return <Loading />;

    if (!loading && portfolios.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum portfólio encontrado.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {portfolios.map((portfolio) => (
            <PortfolioCard
              key={portfolio.id}
              portfolio={portfolio}
              refetch={() => getPortfolios({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Heading>Portfólios</Heading>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        {checkIfHasRole('CAN_CREATE_PORTFOLIO') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Novo
          </Button>
        )}
      </Flex>

      {showFilters ? (
        <Filters onClose={() => setShowFilters(false)} />
      ) : (
        <SelectedFiltersList />
      )}

      {getCurrentComponent()}

      {showAddDialog && (
        <UpsertDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getPortfolios({})}
        />
      )}
    </Box>
  );
};

export default Portfolio;
